const Filters = {
  prisonerNumber: '',
  senderName: '',
  status: 'AwaitingConfirmation',
  after: '',
  before: '',
  sort: '-updated_at',
  skip: 1,
  limit: 10,
};

export default {
  namespaced: true,
  state: {
    filters: { ...Filters },
    defaultFilters: { ...Filters }, // used to set filters back to original
  },
  getters: {},
  mutations: {
    SET_FILTERS(state, value) {
      state.filters = value;
    },
    SET_FILTER_ITEM(state, item) {
      state.filters[item.name] = item.value;
    },
  },
  actions: {
    setFiltersToDefault({ state, commit }, payload) {
      if (state.defaultFilters) {
        const filters = { ...state.defaultFilters };
        filters.status = payload.status;
        commit('SET_FILTERS', { ...filters });
      }
    },
  },
};
